import * as React from "react"
import {
  Book,
  BookDashed,
  Cat,
  Database,
  LayoutDashboard,
  PlusIcon,
  Settings,
  UserCheck,
} from "lucide-react"

import { NavMain } from "./nav-main"
import { NavProjects } from "./nav-projects"
import { NavUser } from "./nav-user"
import { TeamSwitcher } from "./team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "../../../components/ui/sidebar"
import { AuthContext } from "../../../contexts/Auth/Auth.Context"
import { useLocation } from "react-router-dom"
import { Button, Drawer } from "@mantine/core"
import ExcelUploader from "../../../components/ExcelUploader"


export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { state } = React.useContext(AuthContext);

  const [opened, setOpened] = React.useState(false);

  const isAdmin = true;

  const location = useLocation();

  const data = {
    teams: [
      {
        name: "CRHA",
        logo: Cat,
        plan: "v1.0.0",
      }
    ],
    navMain: [
      {
        title: "User Management",
        url: "/home/overview",
        icon: UserCheck,
        isActive: location.pathname.includes("overview"),
      },
      {
        title: "Dataset Management",
        url: "/home/dataset-management",
        icon: Database,
        isActive: location.pathname.includes("dataset-management"),
      },
      {
        title: "Articles & News",
        url: "/home/articles",
        icon: Book,
        isActive: location.pathname.includes("articles"),
      }
    ],
  }
  return (
    <>
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        <div className="px-4 py-2">
        <Button onClick={() => {setOpened(true)}} radius="xl">
          <PlusIcon />
          Upload Dataset
        </Button>
        </div>
        <NavMain items={data.navMain} />
        {isAdmin && (
          <NavProjects
            projects={[
              {
                name: "User Dashboard",
                url: "/dashboard",
                icon: LayoutDashboard,
                isActive: location.pathname.includes("dashboard"),
              },
              {
                name: "Documentation",
                url: "/home/documentation",
                icon: BookDashed,
                isActive: location.pathname.includes("user-management"),
              },
            ]}
          />
        )}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={{
          name: state.userData?.name || "",
          email: state.userData?.username || "",
          avatar: ""
        }} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>

      <Drawer opened={opened} position="right"  onClose={() => setOpened(false)} title="Upload Dataset" padding="sm" size="xl" withOverlay={false}>
          <ExcelUploader />
        </Drawer>
    </>
  )
}
